var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"animated fadeIn"},[_c('confirmation-modal',{attrs:{"id":"concurrent-attendance-modal","msg":_vm.message,"cancel":_vm.goBack}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }